import { ERouteActionTypes, ISetRouteAction } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Установить текущий список чатов ('messages' | 'spam' | 'archive')
 */
export const setRoute = actionGenerator<ERouteActionTypes.SetRoute, ISetRouteAction>(ERouteActionTypes.SetRoute);
